import React from "react";
import classNames from "classnames";
import "../../styles/_card_recipes.scss";
import PropTypes from "prop-types";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const CardRecipes = ({
  title,
  description,
  calories,
  protein,
  imageUrl,
  imageBase64,
  imageFileType,
  className,
  onSelect,
  onInfo,
  recipeId,
  selected = false,
  disabled = false,
}) => {
  const handleInfo = (e) => {
    e.stopPropagation();
    onInfo?.(recipeId);
  };

  const handleInfoKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleInfo(e);
    }
  };

  // ---- helpers ----
  const withUnit = (val, unit) => {
    const s = String(val ?? "").trim();
    if (!s) return "—";
    // if already contains any letters, assume it already has a unit
    return /[a-zA-Z]/.test(s) ? s : `${s} ${unit}`;
  };

  const caloriesText = withUnit(calories, "kcal");
  const proteinText = withUnit(protein, "g");
  // ---------------------------

  return (
    <button
      type="button"
      className={classNames("rcp-card", className, { "is-selected": selected })}
      onClick={() => onSelect?.(title)}
      disabled={disabled}
      aria-label={title ? `Open recipe: ${title}` : "Open recipe"}
      aria-pressed={selected}
    >
      {(imageBase64 || imageUrl) && (
        <div className="rcp-card__image">
          <img
            src={
              imageBase64
                ? `data:${imageFileType || "image/png"};base64,${imageBase64}`
                : imageUrl
            }
            alt={title || "Recipe"}
          />
        </div>
      )}

      <h6 className="rcp-card__title">{title || "No Title available"}</h6>
      <p className="rcp-card__desc">
        {description || "No description available"}
      </p>

      <div className="rcp-card__meta">
        <span className="rcp-chip rcp-chip--cal">Cal: {caloriesText}</span>
        <span className="rcp-chip rcp-chip--protein">
          Protein: {proteinText}
        </span>

        <button
          type="button"
          className="rcp-info-icon-btn"
          onClick={handleInfo}
          onKeyDown={handleInfoKey}
          aria-label="View recipe details"
          tabIndex={0}
          disabled={disabled}
        >
          <InfoOutlinedIcon
            fontSize="small"
            className="rcp-info-icon"
            titleAccess="More info"
            aria-hidden="true"
          />
        </button>
      </div>
    </button>
  );
};

CardRecipes.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  calories: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  protein: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageUrl: PropTypes.string,
  imageBase64: PropTypes.string,
  imageFileType: PropTypes.string,
  className: PropTypes.string,
  onSelect: PropTypes.func,
  onInfo: PropTypes.func,
  recipeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CardRecipes;
